import { useTranslation } from 'i18n';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { ListSkeletonLoader, Page } from 'ui';

import { BuyerMaterialSpecificationUpdateForm } from '../../components/BuyerMaterialSpecificationUpdateForm/BuyerMaterialSpecificationUpdateForm';
import { useGetBuyerMaterialSpecificationDetails } from '../../hooks/useGetBuyerMaterialSpecificationDetails/useGetBuyerMaterialSpecificationDetails';

const LoadingSuspense = () => {
  return <ListSkeletonLoader items={3} />;
};

export const BuyerMaterialSpecificationsEditPage = () => {
  const { t } = useTranslation('orders');
  const { buyerMaterialSpecificationId } = useParams();

  if (!buyerMaterialSpecificationId) {
    throw new Error(t('buyerMaterialSpecifications.editPage.errors.idRequired'));
  }

  const { data } = useGetBuyerMaterialSpecificationDetails({
    buyerMaterialSpecificationId: Number(buyerMaterialSpecificationId),
  });

  return (
    <Page>
      <Page.Title title={t('buyerMaterialSpecifications.editPage.title')} />
      <Page.Divider />
      <Suspense fallback={<LoadingSuspense />}>
        <BuyerMaterialSpecificationUpdateForm
          buyerMaterialSpecificationId={Number(buyerMaterialSpecificationId)}
          buyerMaterialSpecificationData={data}
        />
      </Suspense>
    </Page>
  );
};
